<div style="overflow-y: auto;" mdbModal #addEditParametro="mdb-modal" class="modal fade" id="basicExample" tabindex="-1"
    role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
    [config]="{ backdrop: true, ignoreBackdropClick: true }" (closed)="onClosed($event)">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">{{ mode === 'ADD' ? 'Agregar' : 'Editar' }} Parametro</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="cerrarModal()"><span aria-hidden="true">×</span></button>
            </div>
            <div class="modal-body" [formGroup]="formParametro" *ngIf="formParametro !== null && formParametro !== undefined">
                <div class="form-row">
                    <div class="col-12" style="border-bottom: 1px solid #dee2e6;">
                        <h5 class="modal-title mb-2">Datos parametro</h5>
                    </div>
                    <div class="md-form col-6">
                        <input value="" type="text" class="form-control" id="parametro" placeholder="Nombre del parametro" formControlName="nombre">
                        <label for="parametro">Parametro</label>
                        <!-- ERRORES DEL FORM -->
                        <div *ngIf="formParametro.get('nombre').invalid && (formParametro.get('nombre').dirty || formParametro.get('nombre').touched)">
                            <mdb-error *ngIf="formParametro.get('nombre').hasError('required')">
                                El nombre del parametro es requerido.
                            </mdb-error>
                            <mdb-error *ngIf="formParametro.get('nombre').hasError('espacio')">
                                El nombre no debe contener espacio.
                            </mdb-error>
                        </div>
                    </div>
                    <div class="md-form col-6">
                        <mdb-select label="Tipo parametro" [multiple]="false" [options]="tiposParametro" formControlName="tipo_parametro_codigo"
                            placeholder="Seleccione tipo parametro" [filterEnabled]="true">
                        </mdb-select>
                        <div *ngIf="formParametro.get('tipo_parametro_codigo').invalid && (formParametro.get('tipo_parametro_codigo').dirty || formParametro.get('tipo_parametro_codigo').touched)">
                            <mdb-error *ngIf="formParametro.get('tipo_parametro_codigo').errors.required">
                                El tipo de parametro es requerido.
                            </mdb-error>
                        </div>
                    </div>
                    <div class="md-form col-12">
                        <input value="" type="text" class="form-control" id="descripcion" placeholder="Descripción del parametro" formControlName="descripcion">
                        <label for="descripcion">Descripción</label>
                        <!-- ERRORES DEL FORM -->
                        <div *ngIf="formParametro.get('descripcion').invalid && (formParametro.get('descripcion').dirty || formParametro.get('descripcion').touched)">
                            <mdb-error *ngIf="formParametro.get('descripcion').errors.max">
                                La descripcion no puede tener mas de 100 caracteres.
                            </mdb-error>
                        </div>
                    </div>
                    <ng-container *ngIf="mostrarValorSucursalEmpresa">
                        <div class="md-form col-12">
                            <h5 class="modal-title mb-2">Instancia</h5>
                            <div class="d-flex justify-content-center">
                                <mdb-checkbox [checked]="false" formControlName="es_empresa" (click)="onChangeCheckEmpresa()">Empresa</mdb-checkbox>
                                <mdb-checkbox [checked]="false" formControlName="es_sucursal" (click)="onChangeCheckSucursal()">Sucursal</mdb-checkbox>
                            </div>
                        </div>
                        <div class="md-form col-12" style="border-bottom: 1px solid #dee2e6;" *ngIf="formParametro.get('es_sucursal').value">
                            <mdb-select label="Sucursales" [multiple]="true" [options]="sucursales" formControlName="sucursalesSeleccionada"
                                placeholder="Seleccione sucursal" [filterEnabled]="true">
                            </mdb-select>
                        </div>

                        <div class="col-12" style="border-bottom: 1px solid #dee2e6;"></div>
                        
                        <!-- EMPRESA -->
                        <div class="col-6">
                            <h5 class="modal-title mb-3" style="border-bottom: 1px solid #dee2e6;">Empresa</h5>
                            <div formGroupName="parametroEmpresa" *ngIf="formParametro.get('es_empresa').value">
                                <div class="md-form" *ngIf="formParametro.get('tipo_parametro_codigo').value !== 2">
                                    <label for="valor">Valor</label>
                                    <input type="text" class="form-control" id="valor" placeholder="Valor del parametro" formControlName="valor">
                                </div>
                                <div class="md-form" *ngIf="formParametro.get('tipo_parametro_codigo').value === 2">
                                    <mdb-select label="Valor" [multiple]="false" [options]="opcionesBooleanas" formControlName="valor_booleano"
                                        placeholder="Si / NO" [filterEnabled]="true">
                                    </mdb-select>
                                </div>
                            </div>
                            <blockquote class="blockquote bq-primary" *ngIf="!formParametro.get('es_empresa').value">
                                <p>Seleccione la opcion empresa para agregar valor.</p>
                            </blockquote>
                        </div>
                        <!-- SUCURSAL -->
                        <div formArrayName="listParametroSucursal" class="col-6">
                            <h5 class="modal-title mb-3" style="border-bottom: 1px solid #dee2e6;">Sucursales</h5>
                            <ng-container *ngIf="formParametro.get('listParametroSucursal')['controls'].length > 0">
                                <div *ngFor="let item of formParametro.get('listParametroSucursal')['controls']; index as i" [formGroupName]="i">
                                    <div class="md-form input-group" *ngIf="formParametro.get('tipo_parametro_codigo').value !== 2">
                                      <label for="valor">Valor ({{item.get('sucursal_nombre').value}})</label>
                                      <input type="text" class="form-control" id="valor" placeholder="Valor del parametro" formControlName="valor" aria-describedby="button-addon2">
                                      <div class="input-group-append">
                                        <button mdbBtn color="danger" size="md" class="m-0 px-3 py-2" type="button" id="button-addon2" (click)="quitarSucursal(i)"
                                          mdbWavesEffect>
                                            <mdb-icon fas icon="trash"></mdb-icon>
                                        </button>
                                      </div>
                                    </div>
                                    <div class="md-form input-group align-items-center" *ngIf="formParametro.get('tipo_parametro_codigo').value === 2">
                                        <div class="flex-grow-1">
                                          <mdb-select
                                            [label]="'Valor (' + item.get('sucursal_nombre').value + ')'"
                                            [multiple]="false"
                                            [options]="opcionesBooleanas"
                                            formControlName="valor_booleano"
                                            placeholder="Si / No"
                                            [filterEnabled]="true"
                                            class="w-100">
                                          </mdb-select>
                                        </div>
                                        <div class="input-group-append ml-3">
                                          <button mdbBtn color="danger" size="md" type="button" id="button-addon2" (click)="quitarSucursal(i)" mdbWavesEffect>
                                            <mdb-icon fas icon="trash"></mdb-icon>
                                          </button>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <blockquote class="blockquote bq-primary" *ngIf="formParametro.get('listParametroSucursal')['controls'].length == 0">
                                <p>Seleccion la opcion sucursal y elija al menos una sucursal para agregar valor.</p>
                            </blockquote>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-sm btn-default waves-light" size="sm" data-dismiss="modal"
                    (click)="cerrarModal()" mdbWavesEffect>
                    Cerrar
                </button>
                <button type="button" (click)="guardar()" class="btn btn-sm btn-secondary waves-light" size="sm" mdbWavesEffect>
                    Guardar
                </button>
            </div>
        </div>
    </div>
</div>